<template>
  <div class="chart-wrapper">
    <apexchart type="radialBar" height="320" :options="chartOptions" :series="series" class="elsa-chart" />
  </div>
</template>

<script>
  export default {
    props: {
      series: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      chartOptions() {
        return {
          chart: {
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: "70%",
              },
              dataLabels: {
                name: {
                  offsetY: 35,
                  color: "#478DFF",
                  lineHeight: "133%",
                  fontWeight: "500",
                  fontStyle: "normal",
                  fontFamily: "SF Pro Display",
                },
                value: {
                  offsetY: -10,
                  color: "#478DFF",
                  fontSize: "48px",
                  fontWeight: "bold",
                  fontStyle: "normal",
                  fontFamily: "SF Pro Display",
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: ["#1cf0db"],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: "round",
          },
          labels: [this.range],
        };
      },
      range() {
        const score = this.series[0];
        let range;
        if (score < 56) {
          range = this.$t("charts.elsa_score_range.beginner");
        } else if (score < 67) {
          range = this.$t("charts.elsa_score_range.lower_intermediate");
        } else if (score < 78) {
          range = this.$t("charts.elsa_score_range.intermediate");
        } else if (score < 90) {
          range = this.$t("charts.elsa_score_range.advanced");
        } else {
          range = this.$t("charts.elsa_score_range.native");
        }
        return range;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .chart-wrapper {
    height: 350px;
    display: flex;
    flex-direction: column;

    .elsa-chart {
      margin-top: auto;
      margin-bottom: auto;
    }
  }
</style>
